/* eslint-disable react/require-default-props */
import React, { ReactElement, ReactNode } from 'react';
import { useAuthentication } from '../context/AuthenticationProvider';
import { AuthenticationInProgress } from './AuthenticationInProgress';
import { LoginFragment } from './LoginFragment';

export interface ProtectedRouteProps {
  children?: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps): ReactElement => {
  const { authenticated, inProgress } = useAuthentication();

  if (inProgress) {
    return <AuthenticationInProgress />;
  }
  if (authenticated === true) {
    return <>{children}</>;
  }
  return <LoginFragment />;
};

export default ProtectedRoute;
